import React, { Component } from "react";
import { Chart } from "chart.js";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
const _data = {
  datasets: [
    {
      backgroundColor: "#3F51B5",
      barPercentage: 0.5,
      barThickness: 12,
      borderRadius: 4,
      categoryPercentage: 0.5,
      data: [18, 5, 19, 27, 29, 19, 20],
      label: "This month",
      maxBarThickness: 10,
    },
    {
      backgroundColor: "#EEEEEE",
      barPercentage: 0.5,
      barThickness: 12,
      borderRadius: 4,
      categoryPercentage: 0.5,
      data: [11, 20, 12, 29, 30, 25, 13],
      label: "Last month",
      maxBarThickness: 10,
    },
  ],
  labels: ["3 Sep", "4 Sep", "5 Sep", "6 Sep", "7 Sep", "8 Sep", "9 Sep"],
};

const _options = {
  animation: false,
  cornerRadius: 20,
  layout: { padding: 0 },
  legend: { display: false },
  maintainAspectRatio: false,
  responsive: true,
  xAxes: [
    {
      ticks: {
        fontColor: "textSecondary",
      },
      gridLines: {
        display: false,
        drawBorder: false,
      },
    },
  ],
  yAxes: [
    {
      ticks: {
        fontColor: "textSecondary",
        beginAtZero: true,
        min: 0,
      },
      gridLines: {
        borderDash: [2],
        borderDashOffset: [2],
        drawBorder: false,
        zeroLineBorderDash: [2],
        zeroLineBorderDashOffset: [2],
      },
    },
  ],
  tooltips: {
    backgroundColor: "primary.main",
    bodyFontColor: "textSecondary",
    borderWidth: 1,
    enabled: true,
    footerFontColor: "textSecondary",
    intersect: false,
    mode: "index",
    titleFontColor: "textPrimary",
  },
};
class PowerOutBar extends Component {
  componentDidMount() {
    this.chart = new Chart(this.refs.chart, {
      type: "bar",
      data: _data,
      options: _options,
    });
  }

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  render() {
    return (
      <Card>
        <CardHeader
          action={
            <Button
              endIcon={<ArrowDropDownIcon fontSize="small" />}
              size="small"
            >
              Last 7 days
            </Button>
          }
          title="Power Outage"
        />
        <Divider />
        <CardContent>
          <Box
            sx={{
              height: 400,
              position: "relative",
            }}
          >
            <canvas ref="chart"></canvas>
          </Box>
        </CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <Button
            color="primary"
            endIcon={<ArrowRightIcon fontSize="small" />}
            size="small"
          >
            Overview
          </Button>
        </Box>
      </Card>
    );
  }
}

export default PowerOutBar;
